module.exports = __webpack_public_path__ + "media/loans/red-x-cons-e460ce81.svg";